<template>
  <div class="text-start">
    <!-- Breadcrumb -->
    <nav class="hidden md:block border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div>
          <div class="hidden md:flex text-sm text-gray-600">
            <router-link :to="{ name: 'home' }" class="hover:text-[#518032]">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{ name: 'customers' }" class="hover:text-[#518032]">WiFi users</router-link>
            <span class="mx-2">/</span>
            <span>{{ user.identity }} profile</span>
          </div> 
          <div class="text-xl font-semibold text-gray-800 mt-1">
            {{ user.identity }} Profile
          </div>
        </div>
      </div>
    </nav>

    <!-- Page Content -->
    <div class="py-4 md:px-0 px-2">
      <div class="overflow-auto">
        <div class="md:flex block">
          <!-- Left Profile Card -->
          <div class="rounded-lg shadow-md border bg-white overflow-hidden md:max-w-xs mb-3">
            <img
              src="https://techiegenie.com/wp-content/uploads/2019/06/How-to-disconnect-other-user-from-a-WiFi-Network.jpg"
              class="w-full h-32 object-cover hidden md:block"
            /> 
            <div class="text-center px-4 py-6">
              <h3 class="text-lg font-semibold text-gray-900">
                {{ user.identity || '' }}
              </h3>
              <p class="mt-1 text-gray-600">
                Phone: {{ user.phone_number || 'Not available' }}
              </p>
              <p class="text-gray-600">
                Email: {{ user.email_address || 'Not available' }}
              </p>
            </div>

            <!-- Stats -->
            <div class="flex flex-col items-center border-t text-gray-700 py-4">
              <div class="flex justify-around w-full">
                <div class="text-center">
                  <h2 class="text-xl font-bold text-[#518032]">
                    {{ user.connectionsCount || 0 }}
                  </h2>
                  <span class="text-sm">Connections</span>
                </div>
                <div class="text-center">
                  <h2 class="text-xl font-bold text-[#518032]">
                    {{ user.devicesCount || 0 }}
                  </h2>
                  <span class="text-sm">Devices</span>
                </div>
              </div>

              <!-- View Devices Link -->
              <router-link
                :to="{ name: 'customer_profile', params: { path: 'devices', customerId: customerId } }"
                class="mt-3 text-sm text-[#518032] hover:underline"
              >
                View Devices →
              </router-link>
            </div>

            <!-- Navigation Menu -->
            <ul class="mt-5 flex flex-wrap md:block">
              <li
                v-for="item in menu"
                :key="item.path"
                :class="[ 'border-l-4 my-2',
                  path === item.path
                    ? 'border-[#518032] text-[#518032]'
                    : 'border-transparent hover:border-[#518032]'
                ]"
              >
                <router-link
                  :to="{ name: 'customer_profile', params: { path: item.path, customerId: customerId } }"
                  class="flex items-center px-3 h-8"
                >
                  <feather :type="item.icon" size="16" class="mr-4"></feather>
                  {{ item.label }}
                </router-link>
              </li>
            </ul>
          </div>

          <!-- Right Content Area -->
          <div class="w-full mt-3 md:mt-0 md:mx-4">
            <Devices v-if="path === 'devices'" :customers="[customerId]" :breadcrumb="false" />
            <CustomerDetails v-else-if="path === 'account'" :customer-id="customerId" />
            <Connections v-else :customers="[customerId]" :breadcrumb="false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import Connections from "@/modules/connections/Connections";
import Devices from "@/modules/devices/Devices";
import CustomerDetails from "@/modules/customers/CustomerDetails";

export default {
  name: "CustomerProfile",
  components: { CustomerDetails, Devices, Connections },
  data() {
    return {
      user: Object,
      menu: [
        { path: 'connections', label: 'Connections', icon: 'activity' },
        { path: 'devices', label: 'Devices', icon: 'smartphone' },
        { path: 'account', label: 'Account Info', icon: 'user' },
      ],
    };
  },
  props: {
    customerId: String,
    path: String,
  },
  mounted() {
    this.getCustomerProfile();
  },
  methods: {
    getCustomerProfile() {
      this.loading = true;
      GraphQl.sendRequest(
        `{organization(id:"${this.$store.getters.orgId}"){customer(customerId:"${this.customerId}"){devicesCount connectionsCount identity name first_name last_name middle_name phone_number email_address}}}`
      )
        .then(response => {
          this.user = response.organization.customer;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
